import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { useNavData } from '../../../use-nav-data/use-nav-data';

export function useLeftMenuItems() {
  const { pathname } = useLocation();
  const menuData = useNavData();

  return useMemo(() => {
    const pathRoot = `/${pathname.split('/')[1]}`;

    const menu = menuData.find((item) => item.to === pathRoot);
    return menu?.submenu || [];
  }, [pathname, menuData]);
}
